import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-translate';
import * as JsPDF from 'jspdf';
import { Segment, Form, Button, Container, Grid, Header, Icon, Image } from 'semantic-ui-react';

import KnaufLogoCloud from '../../assets/img/KnaufLogoCloud.png';

import API from '../../services/Api';

import './ExportEmail.css';


class ConnectedExportEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };

    this.handleChangeEmail = this.handleChangeEmail.bind(this);
  }

  dataURItoBlob =(dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const blob = new Blob([ab], { type: mimeString });
    return blob;
  }

  sendPDF() {
    const { email } = this.state;
    const pdf = new JsPDF('p', undefined, undefined, true);
    pdf.addImage(sessionStorage.comblesAmenages, 'PNG', -50, 0, 300, 300, '', 'FAST');
    pdf.addPage();
    pdf.addImage(sessionStorage.compare, 'PNG', -50, 0, 300, 300, '', 'FAST');
    pdf.addPage();
    pdf.addImage(sessionStorage.standard, 'PNG', -50, 0, 300, 300, '', 'FAST');
    pdf.addPage();
    pdf.addImage(sessionStorage.rtMax, 'PNG', -50, 0, 300, 300, '', 'FAST');
    pdf.addPage();
    pdf.addImage(sessionStorage.rtPlus, 'PNG', -50, 0, 300, 300, '', 'FAST');
    const generatedPdf = pdf.output('datauristring');
    const form = new FormData();

    form.append('email', email);
    form.append('myfile', this.dataURItoBlob(generatedPdf), 'export.pdf');
    API.sendMail(form);
  }

  handleChangeEmail(evt, val) {
    const email = val.value;
    this.setState({
      email,
    });
  }

  render() {
    const { t } = this.props;
    const { email } = this.state;
    return (
      <Segment basic id="exportEmailMain">
        <Image src={KnaufLogoCloud} size="large" id="KnaufLogoCloud" />
        <Container>
          <Segment id="windowEmail">
            <Grid textAlign="center" verticalAlign="middle">
              <Grid.Column className="exportColumn">
                <Header as="h3" textAlign="center" className="headerEmail">
                  <Link to="/comblesAmenages">
                    <Icon name="times" className="closeIcon" floated="right" />
                  </Link>
                  {t('export_email_title')}
                  <div className="ui divider" />
                </Header>
                <Form>
                  <h4 className="labelstyling">{t('export_email_label')}</h4>
                  <Form.Input
                    value={email}
                    onChange={(evt, val) => this.handleChangeEmail(evt, val)}
                    name="email"
                  />
                  <Button
                    id="buttonSend"
                    type="submit"
                    role="button"
                    fluid
                    onClick={() => this.sendPDF()}
                  >
                    {t('export_email_button')}
                  </Button>
                </Form>
              </Grid.Column>
            </Grid>
          </Segment>
        </Container>
      </Segment>
    );
  }
}

const ExportEmail = (ConnectedExportEmail);

export default translate('ExportEmail')(ExportEmail);



// WEBPACK FOOTER //
// ./src/components/Protected/ExportEmail.jsx